import { ClerkProvider } from '@clerk/clerk-react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './design/tokens.css';
import { Gate } from './screens/Gate';
import { App } from './App';

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY ?? 'pk_live_Y2xlcmsucHJvamVjdG9yc3R1ZGlvLmlvJA';

// theme: remembered per browser; dark is the default like the app
try { document.documentElement.dataset.theme = localStorage.getItem('pd-theme') === 'light' ? 'light' : 'dark'; } catch { document.documentElement.dataset.theme = 'dark'; }

/** Clerk's components restyled with the same tokens the app uses. */
const appearance = {
  variables: {
    colorPrimary: '#FA5D1F', colorText: 'var(--fg)', colorTextSecondary: 'var(--fg-3)',
    colorBackground: 'var(--bg-panel)', colorInputBackground: 'var(--bg-base)', colorInputText: 'var(--fg)',
    colorDanger: '#FF6A54', fontFamily: 'Archivo, system-ui, sans-serif', borderRadius: '6px',
  },
  elements: { card: { boxShadow: 'none', border: '1px solid var(--bd)' }, footer: { display: 'none' } },
};

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ClerkProvider publishableKey={PUBLISHABLE_KEY} appearance={appearance}>
      <Gate><App /></Gate>
    </ClerkProvider>
  </React.StrictMode>,
);
